import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=8f1ecf14&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=8f1ecf14&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1ecf14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f1ecf14')) {
      api.createRecord('8f1ecf14', component.options)
    } else {
      api.reload('8f1ecf14', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=8f1ecf14&scoped=true", function () {
      api.rerender('8f1ecf14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/Details.vue"
export default component.exports